import { useContext } from 'react';

import { CategoricalBarChartBaseConfigContext } from '../contexts/CategoricalBarChartBaseConfig.context.js';

export const useCategoricalBarChartBaseConfig = () =>
  useContext(CategoricalBarChartBaseConfigContext);
